import { type CSSProperties } from 'react';

import { UAExclusiveSearchResultCardImage } from './UAExclusiveSearchResultCardImage';
import { ExclusiveSearchResultCardPrice } from './SearchResultCardPrice';
import { SearchResultCardPreferences } from './SearchResultCardPreferences';
import { SearchResultCardLocation } from './SearchResultCardLocation';
import { SearchResultCardHeadline } from './SearchResultCardHeadline';
import { SearchResultCardFavoriteButton } from './SearchResultCardFavoriteButton';
import { SearchResultCardContent } from './SearchResultCardContent';
import { ExclusiveSearchResultCardAttributes } from './SearchResultCardAttributes';
import { SearchResultCardArticleWrapper } from './SearchResultCardArticleWrapper';
import { SearchResultCardApproximateLocation } from './SearchResultCardApproximateLocation';

import styles from './SearchResultCardImage.module.css';

export const UAExclusiveSearchResultCard = ({ style }: { style?: CSSProperties }) => (
  <SearchResultCardArticleWrapper style={style}>
    <div className={styles.imageWrapper}>
      <UAExclusiveSearchResultCardImage />
      <SearchResultCardFavoriteButton />
    </div>
    <SearchResultCardContent>
      <SearchResultCardPreferences />
      <SearchResultCardLocation />
      <SearchResultCardHeadline />
      <ExclusiveSearchResultCardPrice />
      <ExclusiveSearchResultCardAttributes />
    </SearchResultCardContent>
    <SearchResultCardApproximateLocation />
  </SearchResultCardArticleWrapper>
);

UAExclusiveSearchResultCard.displayName = 'UAExclusiveSearchResultCard';
